import { useDispatch, useSelector } from 'react-redux';
import { getPassword, getUsername, updatePassword, updateUsername } from '../usersSlice';

export const useUsername = () => {
    const dispatch = useDispatch();
    const username = useSelector(getUsername);

    const onUpdateUsername = (value: string) => {
        dispatch(updateUsername(value));
    };

    return {
        username,
        updateUsername: onUpdateUsername,
    };
};

export const usePassword = () => {
    const dispatch = useDispatch();
    const password = useSelector(getPassword);

    const onUpdatePassword = (value: string) => {
        dispatch(updatePassword(value));
    };

    return {
        password,
        updatePassword: onUpdatePassword,
    };
};
